import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { RelationshipService } from "../api";

// CreateRelative
export const actionCreateRelative = createAsyncThunk(
  "relative/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await RelationshipService.doCreateRelative(data);

      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

// GetListRelationship
export const actionGetListRelationship = createAsyncThunk(
  "relative/list-relationship",
  async (data, { rejectWithValue }) => {
    try {
      
      const res = await RelationshipService.doGetListRelationship(data);

      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

// UpdateRelationship
export const actionUpdateRelationship = createAsyncThunk(
  "relative/update",
  async (data, { rejectWithValue }) => {
    try {
      const res = await RelationshipService.doUpdateRelationship(data);

      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

// DeleteRelationship
export const actionDeleteRelationship = createAsyncThunk(
  "relative/delete-relationship",
  async (data, { rejectWithValue }) => {
    try {
      const res = await RelationshipService.doDeleteRelationship(data);

      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

const RelationshipSlice = createSlice({
  name: "relationship",
  initialState: {
    createRelative: {
      loading: false,
      data: null,
      error: "",
    },
    listRelationship: {
      loading: false,
      data: null,
      error: "",
    },
    updateRelationship: {
      loading: false,
      data: null,
      error: "",
    },
    deleteRelationship: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Relative
      .addCase(actionCreateRelative.pending, (state) => {
        state.createRelative.loading = true;
      })
      .addCase(actionCreateRelative.fulfilled, (state, action) => {
        state.createRelative.loading = false;
        state.createRelative.data = action.payload;
      })
      .addCase(actionCreateRelative.rejected, (state, action) => {
        state.createRelative.loading = false;
        state.createRelative.data = action.payload;
        state.createRelative.error =
          action.error.message || "Something went wrong";
      })
      // actionUpdateRelationship
      .addCase(actionUpdateRelationship.pending, (state) => {
        state.updateRelationship.loading = true;
      })
      .addCase(actionUpdateRelationship.fulfilled, (state, action) => {
        state.updateRelationship.loading = false;
        state.updateRelationship.data = action.payload;
      })
      .addCase(actionUpdateRelationship.rejected, (state, action) => {
        state.updateRelationship.loading = false;
        state.updateRelationship.data = action.payload;
        state.updateRelationship.error =
          action.error.message || "Something went wrong";
      })
      // actionDeleteRelationship
      .addCase(actionDeleteRelationship.pending, (state) => {
        state.deleteRelationship.loading = true;
      })
      .addCase(actionDeleteRelationship.fulfilled, (state, action) => {
        state.deleteRelationship.loading = false;
        state.deleteRelationship.data = action.payload;
      })
      .addCase(actionDeleteRelationship.rejected, (state, action) => {
        state.deleteRelationship.loading = false;
        state.deleteRelationship.data = action.payload;
        state.deleteRelationship.error =
          action.error.message || "Something went wrong";
      })
      // list Relationship
      .addCase(actionGetListRelationship.pending, (state) => {
        state.listRelationship.loading = true;
      })
      .addCase(actionGetListRelationship.fulfilled, (state, action) => {
        state.listRelationship.loading = false;
        state.listRelationship.data = action.payload;
      })
      .addCase(actionGetListRelationship.rejected, (state, action) => {
        state.listRelationship.loading = false;
        state.listRelationship.data = action.payload;
        state.listRelationship.error =
          action.error.message || "Something went wrong";
      });
  },
});

export default RelationshipSlice.reducer;
export const { actions, reducer } = RelationshipSlice;
